import React from 'react';
import { cn } from '../lib/utils';
import { TitleCard } from './title-card';

export function TitleGrid({ titles, className, variant = 'poster' }) {
  if (!titles || titles.length === 0) return null;

  return (
    <ul
      className={cn(
        variant === 'poster'
          ? 'grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 sm:gap-5'
          : 'grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-5 xl:grid-cols-4 xl:gap-6',
        className
      )}
    >
      {titles.map((title, index) => (
        <li key={title.id}>
          <TitleCard title={title} priority={index < 4} variant={variant} />
        </li>
      ))}
    </ul>
  );
}

export default TitleGrid;
